import { useState, useEffect } from 'react';
import { UserHttpService } from 'core/services/user';

const useReferenceForm = (id) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    useEffect(() => {
        const loadReference = async () => {
            if (!id) return;
            
            setIsLoading(true);
            setError(null);
            
            try {
                const response = await UserHttpService.getReference(id);
                setData(response.data);
            } catch (err) {
                setError(err.message || 'Failed to load reference');
            } finally {
                setIsLoading(false);
            }
        };

        loadReference();
    }, [id]);

    const saveReference = async (formData) => {
        setIsLoading(true);
        setError(null);

        try {
            const referenceData = {
                name: formData.name,
                position: formData.position,
                location: formData.location,
                email: formData.email,
                phone_number: formData.phone_number,
                cv: formData?.cv ?? null
            };
            
            if (id) {
                await UserHttpService.updateReference(id, referenceData);
            } else {
                await UserHttpService.createReference(referenceData);
            }
        } catch (err) {
            setError(err.message || 'Failed to save reference');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        isLoading,
        error,
        data,
        saveReference
    };
};

export default useReferenceForm; 